import { render, staticRenderFns } from "./Comissao.vue?vue&type=template&id=aee4adda&scoped=true&"
import script from "./Comissao.vue?vue&type=script&lang=ts&"
export * from "./Comissao.vue?vue&type=script&lang=ts&"
import style0 from "./Comissao.vue?vue&type=style&index=0&id=aee4adda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee4adda",
  null
  
)

export default component.exports